export const TeamSection = () => {
  return (
    <section className="py-16 md:py-24 bg-[#F8FAFC]" data-testid="team-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image - team photo */}
          <div className="relative animate-fade-in-up">
            <div className="relative overflow-hidden rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_fonster-renovering/artifacts/rodgni3p_Fo%CC%88nsterma%CC%8Alning.jpg"
                alt="Vårt erfarna team av målare i Stockholm"
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#C0392B] -z-10" aria-hidden="true" />
          </div>

          {/* Content */}
          <div className="animate-fade-in-up delay-200">
            <span className="text-[#C0392B] font-medium text-sm uppercase tracking-wider mb-4 block">
              Möt teamet
            </span>
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-[#1F2937] mb-6">
              Erfarna målare som bryr sig om kvalitet
            </h2>
            <p className="text-[#64748B] text-lg mb-6 leading-relaxed">
              Bakom varje välmålat fönster finns ett dedikerat team med över 30 års samlad 
              erfarenhet. Vi är stolta över vårt hantverk och behandlar varje projekt 
              som om det vore vårt eget hem.
            </p>
            <p className="text-[#64748B] mb-8 leading-relaxed">
              Från den första kontakten till slutbesiktningen är vi måna om att du ska 
              känna dig trygg och informerad. Vårt mål är inte bara nöjda kunder – 
              utan kunder som rekommenderar oss vidare.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-[#2C3E50]">30+</div>
                <div className="text-sm text-[#64748B]">År i branschen</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-[#2C3E50]">1000+</div>
                <div className="text-sm text-[#64748B]">Projekt</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-[#2C3E50]">98%</div>
                <div className="text-sm text-[#64748B]">Nöjda kunder</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
